import { useHasOpened } from '@atlassian/jira-software-onboarding-quickstart-has-opened';

export const useCanShowQuickstartNudge = () => {
	const [{ hasOpened }] = useHasOpened();
	return hasOpened;
};
